module.exports = __webpack_public_path__ + "static/media/logoMOVES.09e898f2.svg";